const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "EUR"
});

export const formatPrice = (price: string | number): string =>
  price === "NaN"
    ? "N/A"
    : formatter.format(price as number).replace(".00", "");
